<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'Akamai', to: { path: '/akamai' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Akamai Cache</h2>
      <v-spacer></v-spacer>
      <!-- <button class="btn btn-primary" @click="toAkamaiCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增 Akamai</span>
      </button> -->
    </div>
    <!-- block -->
    <div class="block mb-5">
      <AkamaiTable></AkamaiTable>
    </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import AkamaiTable from '@/views/E-5__Akamai/c/AkamaiTable.vue';

export default {
  components: {
    Breadscrumbs,
    AkamaiTable,
  },
  created() {
    this.clear();
    this.getAkamaiList();
  },
  computed: {
  },
  methods: {
    ...mapActions('akamai', {
      getAkamaiList: 'find',
      clear: 'clear',
    }),
    toAkamaiCreate() {
      this.$router.push('/akamai/create');
    }
  },
};
</script>

<style></style>
